import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a number as a signed string for display.
 *
 * • Positive values are prefixed with '+'
 * • Negative values retain their '-' sign
 * • Zero is displayed without a sign
 * • Values are rounded to the specified number of decimal places
 *
 * Examples:
 * • 15.5 → "+16"
 * • 15.49 (1 decimal place) → "+15.5"
 * • -8.34 (1 decimal place) → "-8.3"
 * • 0 → "0"
 *
 * @param value The number to format.
 * @param decimalPlaces The number of decimal places to display. Defaults to 0.
 * @returns A formatted string with the appropriate sign.
 */
// TODO: Generalize this pipe into a configurable number-formatting pipe to
// support future formatting requirements and avoid pipe-order dependencies.
@Pipe({
    name: 'signedNumber',
    standalone: false
})
export class SignedNumberPipe implements PipeTransform {
  transform(
    value: number | null | undefined,
    decimalPlaces = 0
  ): string {
    if (value == null) {
      return '';
    }

    const formatted = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }).format(value);

    return value > 0 ? `+${formatted}` : formatted;
  }
}